import React, { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import './scroll-progress.css'

gsap.registerPlugin(ScrollTrigger)

// Fine ligne bleue en haut de page qui se remplit selon la progression du scroll.
// S'appuie sur ScrollTrigger (synchronisé avec Lenis via gsap.ticker côté LenisProvider).
export default function ScrollProgress() {
  const barRef = useRef(null)

  useEffect(() => {
    const trigger = ScrollTrigger.create({
      start: 0,
      end: 'max',
      onUpdate: (self) => {
        gsap.set(barRef.current, { scaleX: self.progress })
      },
    })
    return () => trigger.kill()
  }, [])

  return (
    <div className="scroll-progress-track" aria-hidden="true">
      <div ref={barRef} className="scroll-progress-bar"></div>
    </div>
  )
}
